import { RestClientService } from '@app/app/shared/services/rest-client.service';
import { environment } from '@app/environments/environment';
import { ApiJoinDataService } from './api-join-data.service';
import { JoinDataService } from './join-data.service';
import { MockJoinDataService } from './mock-join-data.service';

export function joinServiceFactory(client: RestClientService): JoinDataService {
  if (environment.dataProvider === 'mock') {
    return new MockJoinDataService();
  }
  return new ApiJoinDataService(client);
}
